import { render } from "./QuizFinder.vue?vue&type=template&id=6f033926&scoped=true&ts=true"
import script from "./QuizFinder.vue?vue&type=script&lang=ts"
export * from "./QuizFinder.vue?vue&type=script&lang=ts"

import "./QuizFinder.vue?vue&type=style&index=0&id=6f033926&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f033926"]])

export default __exports__